import { EstateBusinesses } from '@/modules/estate/EstateBusinesses/EstateBusinesses';

export function ClientEstateBusinessesPage() {
  return <EstateBusinesses />;
}
